import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowDownFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.842 8c1.03 0 1.545 1.224.817 1.94l-6.842 6.727a1.17 1.17 0 0 1-1.634 0L4.34 9.94C3.613 9.224 4.128 8 5.158 8h13.684Z", fill: color }));
};
export default factorySvgIcon(SvgArrowDownFilled);
//# sourceMappingURL=SvgArrowDownFilled.js.map